import React from 'react';

interface AppBannerProps {
  postId?: number;
}

export default function AppBanner({ postId }: AppBannerProps): React.ReactElement {
  const handleOpenInApp = () => {
    if (postId) {
      const deepLink = `wispa://replies/${postId}`;
      window.location.href = deepLink;
      // Fallback to download page after short delay if app doesn't open
      setTimeout(() => {
        if (!document.hidden) {
          window.location.href = '/download';
        }
      }, 2000);
    } else {
      window.location.href = '/download';
    }
  };

  return (
    <div className="app-banner-overlay">
      <span>See more posts like this in the Hereabout app! </span>
      <button
        onClick={handleOpenInApp}
        className="download-link"
        style={{
          background: 'none',
          border: 'none',
          color: 'white',
          textDecoration: 'underline',
          fontWeight: '500',
          cursor: 'pointer'
        }}
      >
        Open in App
      </button>
      <span> | </span>
      <a href="/download" className="download-link">Download</a>
    </div>
  );
}
